(function () {
  'use strict';
  if (window.__eyemodePdpOffersLoaded) return;
  window.__eyemodePdpOffersLoaded = true;

  function initialize(root) {
    if (root.dataset.offersReady === 'true') return;
    root.dataset.offersReady = 'true';

    var slides = Array.from(root.querySelectorAll('[data-offer-slide]'));
    var count = root.querySelector('[data-offer-count]');
    var allOffers = root.querySelector('[data-offer-all]');
    var slideArea = root.querySelector('[data-offer-slides]');
    var actions = root.querySelector('[data-offer-actions]');
    var openButton = root.querySelector('[data-offer-open]');
    var status = root.querySelector('[data-offer-status]');
    var active = 0;
    var rotationTimer = null;
    var expanded = false;
    var variants = {};
    var copyTimers = new WeakMap();
    try { variants = JSON.parse(root.querySelector('[data-offer-variants]').textContent); } catch (error) {}

    function show(index) {
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.hidden = i !== active; });
      if (count) count.textContent = (active + 1) + '/' + slides.length;
      window.clearTimeout(rotationTimer);
      if (!expanded && slides.length > 1) {
        rotationTimer = window.setTimeout(function () {
          if (root.isConnected) show(active + 1);
        }, 4000);
      }
    }

    function setExpanded(open) {
      if (!allOffers || !slideArea || !actions) return;
      expanded = open;
      window.clearTimeout(rotationTimer);
      root.classList.toggle('eyemode-offers--expanded', open);
      slideArea.hidden = open;
      actions.hidden = open;
      allOffers.hidden = !open;
      if (openButton) openButton.setAttribute('aria-expanded', String(open));
      if (open) {
        var closeButton = allOffers.querySelector('[data-offer-close]');
        if (closeButton) closeButton.focus({ preventScroll: true });
      } else {
        show(active);
        if (openButton) openButton.focus({ preventScroll: true });
      }
    }

    function updateInstallment(variantId) {
      var price = variants[String(variantId)];
      if (typeof price !== 'number' || !Number.isFinite(price)) return;
      var amount = Math.round(price / 300);
      var formatted;
      try {
        formatted = new Intl.NumberFormat('en-IN', {
          style: 'currency', currency: root.dataset.currency || 'INR',
          minimumFractionDigits: 0, maximumFractionDigits: 0
        }).format(amount);
      } catch (error) { formatted = '₹' + amount.toLocaleString('en-IN'); }
      root.querySelectorAll('[data-offer-installment]').forEach(function (el) { el.textContent = formatted; });
    }

    function legacyCopy(code) {
      var input = document.createElement('textarea');
      input.value = code;
      input.readOnly = true;
      input.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0;';
      root.appendChild(input);
      input.select();
      input.setSelectionRange(0, code.length);
      var copied = false;
      try { copied = document.execCommand('copy'); } catch (error) {}
      input.remove();
      return copied;
    }

    async function copy(button) {
      var code = button.getAttribute('data-offer-copy');
      var copied = false;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try { await navigator.clipboard.writeText(code); copied = true; } catch (error) {}
      }
      if (!copied) copied = legacyCopy(code);
      if (status) status.textContent = copied ? code + ' copied.' : 'Use ' + code + ' at checkout.';
      if (!copied) { button.focus({ preventScroll: true }); return; }
      var label = button.querySelector('[data-offer-copy-label]');
      if (!label) return;
      window.clearTimeout(copyTimers.get(button));
      label.textContent = 'COPIED';
      button.setAttribute('aria-label', 'Code ' + code + ' copied');
      copyTimers.set(button, window.setTimeout(function () {
        label.textContent = code;
        button.setAttribute('aria-label', 'Copy code ' + code);
      }, 1800));
      button.focus({ preventScroll: true });
    }

    root.addEventListener('click', function (event) {
      var button = event.target.closest('button');
      if (!button || !root.contains(button)) return;
      if (button.hasAttribute('data-offer-prev')) show(active - 1);
      else if (button.hasAttribute('data-offer-next')) show(active + 1);
      else if (button.hasAttribute('data-offer-copy')) copy(button);
      else if (button.hasAttribute('data-offer-open')) setExpanded(true);
      else if (button.hasAttribute('data-offer-close')) setExpanded(false);
    });

    root.addEventListener('keydown', function (event) {
      if (expanded && event.key === 'Escape') {
        event.preventDefault();
        setExpanded(false);
        return;
      }
      if (!event.target.closest('[data-offer-prev], [data-offer-next]')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        show(active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });

    var swipeX = 0;
    var swipeY = 0;
    if (slideArea) {
      slideArea.addEventListener('touchstart', function (event) {
        swipeX = event.changedTouches[0].clientX;
        swipeY = event.changedTouches[0].clientY;
      }, { passive: true });
      slideArea.addEventListener('touchend', function (event) {
        if (event.target.closest('button')) return;
        var dx = event.changedTouches[0].clientX - swipeX;
        var dy = event.changedTouches[0].clientY - swipeY;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(active + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    document.addEventListener('eyemode:variant-change', function (event) {
      if (event.detail) updateInstallment(event.detail.variantId);
    });
    // The existing PDP emits this event for every colour selection.
    updateInstallment(root.dataset.initialVariantId);
    show(0);
  }

  function start(scope) {
    (scope || document).querySelectorAll('[data-eyemode-offers]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(); }, { once: true });
  else start();
  document.addEventListener('shopify:section:load', function (event) { start(event.target); });
}());
